var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85547 5.35756C4.85547 3.10897 6.67831 1.28613 8.9269 1.28613H41.0698C43.3183 1.28613 45.1412 3.10897 45.1412 5.35756V12.3288H4.85547V5.35756ZM4.85547 13.5788V26.1611H24.9983H45.1412V13.5788H4.85547ZM24.3733 27.4111H4.85547V44.6433C4.85547 46.8919 6.67831 48.7147 8.9269 48.7147H24.3733V27.4111ZM25.6233 48.7147V27.4111H45.1412V44.6433C45.1412 46.8919 43.3183 48.7147 41.0698 48.7147H25.6233ZM33.927 36.8977C34.2722 36.8977 34.552 37.1775 34.552 37.5227V41.0941C34.552 41.4393 34.2722 41.7191 33.927 41.7191C33.5818 41.7191 33.302 41.4393 33.302 41.0941V37.5227C33.302 37.1775 33.5818 36.8977 33.927 36.8977ZM16.6949 37.5227C16.6949 37.1775 16.415 36.8977 16.0699 36.8977C15.7247 36.8977 15.4449 37.1775 15.4449 37.5227V41.0941C15.4449 41.4393 15.7247 41.7191 16.0699 41.7191C16.415 41.7191 16.6949 41.4393 16.6949 41.0941V37.5227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.bfda40262abf592b15d119c91d7be6a5.svg";
export { ForwardRef as ReactComponent };